export default "__VITE_ASSET__245b1985__"